var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rotateTips"},[_c('a',{staticClass:"arrow",attrs:{"href":"#"}},[_vm._v("Refresh")]),_c('div',{staticClass:"tips"},[_c('p',{staticStyle:{"margin-bottom":"20px"}},[_vm._v("请横屏观看哦")]),_c('p',[_vm._v("安卓系统请打开自动旋转；"),_c('br'),_vm._v("微信【设置】->【通用】->"),_c('br'),_vm._v("【开启横屏模式】;")])])])
}]

export { render, staticRenderFns }